import template   from './app.html'
import controller from './app.controller'
import './app.styl'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/app.component.js